// v1.0.96 — Twilio Verify SMS OTP via modal centré (style Stripe/Discord).
//
// Architecture :
//   - Bouton "Vérifier" à côté du champ téléphone (inline, brand colors)
//   - Click → ouvre #psPhoneVerifyOverlay (overlay sombre + carte centrée)
//   - 6 boxes individuelles auto-advance + auto-paste
//   - Bouton Verify auto-disabled tant que les 6 chiffres pas remplis
//   - Animation success (boxes vertes + checkmark) → ferme le modal → badge "✓ Vérifié"
//   - Resend : countdown 30s avant de pouvoir renvoyer
//   - Change number : ferme le modal et focus le champ téléphone
//   - ESC pour fermer + click overlay backdrop pour fermer
//   - Focus trap dans le modal pendant ouverture
//
// Si user modifie le téléphone après vérification → reset state, redemande verify.

import { S } from './state.js';
import { $ } from './dom.js';
import { apiPost } from './api.js';

var PHONE_NANP_RE = /^(\+?1[\s.\-]?)?\(?[2-9]\d{2}\)?[\s.\-]?[2-9]\d{2}[\s.\-]?\d{4}$/;
var RESEND_COOLDOWN_S = 30;

function cfg() { return window.ProbotSoum || {}; }
function fr()  { return ( cfg().lang || 'fr' ) === 'fr'; }
function tr( frTxt, enTxt ) { return fr() ? frTxt : enTxt; }

function isValidFormat( v ) {
	return PHONE_NANP_RE.test( String( v || '' ).trim() );
}

// v1.1.59 — Délègue à apiPost() qui inject automatiquement le token anti-bot
// (recaptcha_token via window.grecaptcha si reCAPTCHA actif). Avant : callApi
// local faisait un fetch nu sans token → Bot_Protection::guard_rest rejetait
// avec 403 en prod (le test mode local ne le voyait pas parce qu'aucun
// provider configuré → fail-open).
function callApi( path, body, action ) {
	return apiPost( path, body || {}, { recaptchaAction: action || 'verify_phone' } );
}

// ─────────────────────────────────────────────────────────────────────────
// Modal state
// ─────────────────────────────────────────────────────────────────────────
var resendTimer = null;
var resendSecondsLeft = 0;

function getDigits() { return [].slice.call( document.querySelectorAll( '.ps-pv-digit' ) ); }
function getCode()   { return getDigits().map( function ( i ) { return i.value || ''; } ).join( '' ); }

function setStatus( msg, kind ) {
	var s = $( 'psPvStatus' );
	if ( ! s ) return;
	s.textContent = msg || '';
	s.className = 'ps-pv-status' + ( kind ? ' is-' + kind : '' );
}

function setDigitClass( cls ) {
	getDigits().forEach( function ( d ) {
		d.classList.remove( 'is-error', 'is-success' );
		if ( cls ) d.classList.add( cls );
	} );
}

function updateSubmitState() {
	var btn = $( 'psPvSubmit' );
	if ( ! btn ) return;
	btn.disabled = getCode().length !== 6;
}

function clearDigits() {
	getDigits().forEach( function ( d ) {
		d.value = '';
		d.classList.remove( 'is-filled', 'is-error', 'is-success' );
	} );
	updateSubmitState();
}

function focusFirstDigit() {
	var first = document.querySelector( '.ps-pv-digit[data-idx="0"]' );
	if ( first ) first.focus();
}

function startResendCountdown() {
	resendSecondsLeft = RESEND_COOLDOWN_S;
	var btn  = $( 'psPvResend' );
	var span = $( 'psPvResendCountdown' );
	if ( btn ) btn.disabled = true;
	if ( span ) span.textContent = ' (' + resendSecondsLeft + 's)';
	clearInterval( resendTimer );
	resendTimer = setInterval( function () {
		resendSecondsLeft--;
		if ( resendSecondsLeft <= 0 ) {
			clearInterval( resendTimer );
			if ( btn )  btn.disabled = false;
			if ( span ) span.textContent = '';
		} else {
			if ( span ) span.textContent = ' (' + resendSecondsLeft + 's)';
		}
	}, 1000 );
}

function openModal() {
	var overlay = $( 'psPhoneVerifyOverlay' );
	if ( ! overlay ) return;
	overlay.classList.add( 'is-open' );
	overlay.setAttribute( 'aria-hidden', 'false' );
	document.body.style.overflow = 'hidden';
	setTimeout( focusFirstDigit, 100 );
}

function closeModal() {
	var overlay = $( 'psPhoneVerifyOverlay' );
	if ( ! overlay ) return;
	overlay.classList.remove( 'is-open' );
	overlay.setAttribute( 'aria-hidden', 'true' );
	document.body.style.overflow = '';
	clearInterval( resendTimer );
	clearDigits();
	setStatus( '', '' );
}

// ─────────────────────────────────────────────────────────────────────────
// Verified badge (inline next to phone field)
// ─────────────────────────────────────────────────────────────────────────
function showVerifiedBadge() {
	var badge = $( 'phoneVerifiedBadge' );
	var btn   = $( 'btnVerifyPhone' );
	if ( badge ) badge.classList.add( 'is-visible' );
	if ( btn )   btn.classList.remove( 'is-visible' );
	var inp = $( 'inTel' );
	if ( inp ) inp.readOnly = true;
	// v1.1.2 — Clear le message d'erreur "Please verify your phone..." dans le
	// champ f-tel quand la vérification réussit. Sinon le message rouge reste
	// affiché même si le badge "✓ Verified" est là.
	var ftel = document.getElementById( 'f-tel' );
	if ( ftel ) {
		ftel.classList.remove( 'err' );
		var em = ftel.querySelector( '.emsg' );
		if ( em ) em.style.display = 'none';
	}
}

function hideVerifiedBadge() {
	var badge = $( 'phoneVerifiedBadge' );
	if ( badge ) badge.classList.remove( 'is-visible' );
	var inp = $( 'inTel' );
	if ( inp ) inp.readOnly = false;
}

function updateVerifyButtonVisibility() {
	var enabled = !! cfg().phoneVerifyEnabled;
	var btn = $( 'btnVerifyPhone' );
	if ( ! btn || ! enabled ) {
		if ( btn ) btn.classList.remove( 'is-visible' );
		return;
	}
	if ( S.phoneVerified ) {
		btn.classList.remove( 'is-visible' );
		return;
	}
	var inp = $( 'inTel' );
	var v   = inp ? inp.value.trim() : '';
	if ( isValidFormat( v ) ) {
		btn.classList.add( 'is-visible' );
	} else {
		btn.classList.remove( 'is-visible' );
	}
}

// ─────────────────────────────────────────────────────────────────────────
// API actions
// ─────────────────────────────────────────────────────────────────────────
function sendOtp() {
	var inp = $( 'inTel' );
	if ( ! inp ) return;
	var phone = inp.value.trim();
	if ( ! isValidFormat( phone ) ) {
		setStatus( tr( 'Numéro invalide.', 'Invalid number.' ), 'error' );
		return;
	}

	setStatus( tr( 'Envoi en cours…', 'Sending…' ), 'loading' );

	callApi( 'verify-phone-send', { phone: phone, lang: cfg().lang || 'en' }, 'verify_phone_send' )
		.then( function ( r ) {
			if ( ! r || ! r.success ) {
				setStatus( ( r && r.error ) || tr( 'Erreur — réessayez.', 'Error — please retry.' ), 'error' );
				return;
			}
			S.phoneE164  = r.data && r.data.phone_e164  ? r.data.phone_e164  : null;
			S.phoneHuman = r.data && r.data.phone_human ? r.data.phone_human : phone;
			// Update modal phone display
			var ph = $( 'psPvPhone' );
			if ( ph ) ph.textContent = S.phoneHuman;
			setStatus( tr( '✓ Code envoyé', '✓ Code sent' ), 'success' );
			startResendCountdown();
			setTimeout( function () { setStatus( '', '' ); }, 1500 );
		} )
		.catch( function () {
			setStatus( tr( 'Erreur réseau.', 'Network error.' ), 'error' );
		} );
}

function checkOtp() {
	var code  = getCode();
	if ( code.length !== 6 ) return;
	var phone = ( $( 'inTel' ) || {} ).value || '';

	setStatus( tr( 'Vérification…', 'Verifying…' ), 'loading' );
	var btn = $( 'psPvSubmit' );
	if ( btn ) btn.disabled = true;

	callApi( 'verify-phone-check', { phone: phone, code: code }, 'verify_phone_check' )
		.then( function ( r ) {
			if ( ! r || ! r.success ) {
				setStatus( ( r && r.error ) || tr( 'Code incorrect.', 'Wrong code.' ), 'error' );
				setDigitClass( 'is-error' );
				if ( btn ) btn.disabled = false;
				// Clear digits after shake animation so user can retry
				setTimeout( function () {
					clearDigits();
					focusFirstDigit();
				}, 800 );
				return;
			}
			S.phoneVerified = true;
			S.phoneE164     = ( r.data && r.data.phone_e164 ) ? r.data.phone_e164 : S.phoneE164;
			setDigitClass( 'is-success' );
			setStatus( tr( '✓ Numéro vérifié !', '✓ Number verified!' ), 'success' );
			// Close modal after brief success animation
			setTimeout( function () {
				closeModal();
				showVerifiedBadge();
			}, 800 );
		} )
		.catch( function () {
			setStatus( tr( 'Erreur réseau.', 'Network error.' ), 'error' );
			if ( btn ) btn.disabled = false;
		} );
}

// ─────────────────────────────────────────────────────────────────────────
// Modal bindings (called once on init)
// ─────────────────────────────────────────────────────────────────────────
function bindModalDigits() {
	var digits = getDigits();
	if ( ! digits.length ) return;

	digits.forEach( function ( inp, idx ) {
		// Filter to digits only + advance focus + back-erase to previous
		inp.addEventListener( 'input', function ( e ) {
			var v = ( e.target.value || '' ).replace( /\D/g, '' );
			if ( v.length > 1 ) {
				// Paste of multiple digits — distribute across boxes
				var chars = v.split( '' );
				chars.forEach( function ( ch, i ) {
					if ( digits[ idx + i ] ) {
						digits[ idx + i ].value = ch;
						digits[ idx + i ].classList.add( 'is-filled' );
					}
				} );
				var nextIdx = Math.min( idx + chars.length, digits.length - 1 );
				digits[ nextIdx ].focus();
			} else {
				e.target.value = v;
				if ( v ) {
					inp.classList.add( 'is-filled' );
					if ( idx < digits.length - 1 ) digits[ idx + 1 ].focus();
				} else {
					inp.classList.remove( 'is-filled' );
				}
			}
			// Clear error state on edit
			digits.forEach( function ( d ) { d.classList.remove( 'is-error' ); } );
			updateSubmitState();
			// Auto-submit when 6 digits filled
			if ( getCode().length === 6 ) checkOtp();
		} );

		inp.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Backspace' && ! inp.value && idx > 0 ) {
				digits[ idx - 1 ].focus();
				digits[ idx - 1 ].value = '';
				digits[ idx - 1 ].classList.remove( 'is-filled' );
				updateSubmitState();
			} else if ( e.key === 'ArrowLeft' && idx > 0 ) {
				digits[ idx - 1 ].focus();
			} else if ( e.key === 'ArrowRight' && idx < digits.length - 1 ) {
				digits[ idx + 1 ].focus();
			}
		} );

		// Auto-select on focus for easy overwrite
		inp.addEventListener( 'focus', function () { inp.select(); } );
	} );
}

function bindModalActions() {
	var overlay = $( 'psPhoneVerifyOverlay' );
	if ( ! overlay ) return;

	// Close on backdrop click (but not on modal content click)
	overlay.addEventListener( 'click', function ( e ) {
		if ( e.target === overlay ) closeModal();
	} );

	// Close on ESC
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && overlay.classList.contains( 'is-open' ) ) {
			closeModal();
		}
	} );

	var closeBtn = $( 'psPvClose' );
	if ( closeBtn ) closeBtn.addEventListener( 'click', closeModal );

	var submit = $( 'psPvSubmit' );
	if ( submit ) submit.addEventListener( 'click', checkOtp );

	var resend = $( 'psPvResend' );
	if ( resend ) resend.addEventListener( 'click', function () {
		if ( resendSecondsLeft > 0 ) return;
		clearDigits();
		focusFirstDigit();
		sendOtp();
	} );

	var change = $( 'psPvChangeNumber' );
	if ( change ) change.addEventListener( 'click', function () {
		closeModal();
		var inp = $( 'inTel' );
		if ( inp ) {
			inp.readOnly = false;
			inp.focus();
			inp.select();
		}
	} );
}

// ─────────────────────────────────────────────────────────────────────────
// Main entry point — bound from bindings.js after DOM ready
// ─────────────────────────────────────────────────────────────────────────
export function bindPhoneVerify() {
	var inTel = $( 'inTel' );
	if ( ! inTel ) return;

	// User changes the phone number → reset verification state
	inTel.addEventListener( 'input', function () {
		if ( S.phoneVerified ) {
			S.phoneVerified = false;
			S.phoneE164 = null;
			hideVerifiedBadge();
		}
		updateVerifyButtonVisibility();
	} );

	// "Verify" button → open modal + immediately trigger sendOtp
	var sendBtn = $( 'btnVerifyPhone' );
	if ( sendBtn ) sendBtn.addEventListener( 'click', function () {
		clearDigits();
		setStatus( '', '' );
		var ph = $( 'psPvPhone' );
		if ( ph ) ph.textContent = ( $( 'inTel' ) || {} ).value || '—';
		openModal();
		sendOtp();
	} );

	bindModalDigits();
	bindModalActions();
	updateVerifyButtonVisibility();
}
